export default __webpack_public_path__ + "static/media/polygon.1140771b.png";